import { CheckCircle2, AlertTriangle, AlertCircle } from 'lucide-react';

type BadgeStatus = 'good' | 'partial' | 'missing';

const STYLES: Record<BadgeStatus, string> = {
  good: 'bg-green-50 text-green-700 border-green-200',
  partial: 'bg-amber-50 text-amber-700 border-amber-200',
  missing: 'bg-red-50 text-red-700 border-red-200',
};

const LABELS: Record<BadgeStatus, string> = {
  good: 'Good',
  partial: 'Partial',
  missing: 'Missing',
};

export function StatusBadge({ status }: { readonly status: BadgeStatus }) {
  const icons: Record<BadgeStatus, React.ReactNode> = {
    good: <CheckCircle2 className="w-3 h-3" />,
    partial: <AlertTriangle className="w-3 h-3" />,
    missing: <AlertCircle className="w-3 h-3" />,
  };

  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium rounded-full border ${STYLES[status]}`}>
      {icons[status]} {LABELS[status]}
    </span>
  );
}
